var _path, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgJackpotStarSilverIcon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 113,
    height: 108,
    viewBox: "0 0 113 108",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M46.1988 9.85691C50.4258 1.34067 62.5737 1.34066 66.8007 9.8569L73.2121 22.7742C75.6254 27.6363 80.2756 31.0004 85.6487 31.7712L99.8438 33.8076C109.312 35.1658 113.08 46.8153 106.202 53.4613L96.0585 63.2616C92.1249 67.0622 90.3304 72.5652 91.2674 77.9541L93.7038 91.9669C95.3364 101.357 85.4942 108.543 77.0475 104.129L64.1419 97.3847C59.3543 94.8828 53.6452 94.8828 48.8577 97.3847L35.9521 104.129C27.5053 108.543 17.6632 101.357 19.2958 91.9669L21.7322 77.9541C22.6691 72.5652 20.8747 67.0622 16.9411 63.2616L6.79805 53.4613C-0.0804254 46.8153 3.68804 35.1658 13.1558 33.8076L27.3509 31.7712C32.7239 31.0004 37.3741 27.6363 39.7874 22.7742L46.1988 9.85691Z",
    fill: "url(#paint0_linear_971_8324)",
    stroke: "url(#paint1_linear_971_8324)",
    strokeWidth: 5
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_971_8324",
    x1: 56.1741,
    y1: 15.6393,
    x2: 57.4338,
    y2: 104.177,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0291665,
    stopColor: "#C7C7C7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.221875,
    stopColor: "#747474"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.378125,
    stopColor: "#D3D3D3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.378225,
    stopColor: "#D3D3D3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.461458,
    stopColor: "#CCCCCC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.690625,
    stopColor: "#474747"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.872917,
    stopColor: "#787878"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#989898"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_971_8324",
    x1: 56.245,
    y1: 0.131089,
    x2: 84.9124,
    y2: 108.923,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#7E8186"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E7EAF1"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgJackpotStarSilverIcon);
export default __webpack_public_path__ + "static/media/jackpot_star_silver_icon.1f29033303b4515fdfd2d916e390006f.svg";
export { ForwardRef as ReactComponent };